import { render, staticRenderFns } from "./ReceivableEdit.vue?vue&type=template&id=636c9ca6&"
import script from "./ReceivableEdit.vue?vue&type=script&lang=js&"
export * from "./ReceivableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports